import { Checkbox, MultiSelect, RangeSlider, Select } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useEffect, useRef, useState } from "react";
// import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { withTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import CompleteProfile from "../../components/CompleteProfile";
import InputField from "../../components/inputField";
import Page from "../../components/Page";
import { backendUrl } from "../../constants";
import routeNames from "../../routes/routeNames";
import "./styles.css";

const Index = ({ t }) => {
  const location = useLocation();
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const [emp, setEmp] = useState([]);
  const [edu, setEdu] = useState([]);
  const [exp, setExp] = useState([]);
  const [skills, setSkills] = useState([]);
  const [industry, setIndustry] = useState([]);
  const [jobData, setJobData] = useState({
    createdBy: createdBy.id,
    commission: false,
    salaryType: "hourly",
  });
  // const [editorState, setEditorState] = useState();
  const [loc, setLoc] = useState([]);

  //employment type
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/jobType`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setEmp((emp) => [...emp, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //employee location
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}empLocation/listEmpLocation/${createdBy.id}`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.locationName + ", " + obj.city };
          setLoc((loc) => [...loc, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //education
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/education`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setEdu((edu) => [...edu, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //experience
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/experience`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setExp((exp) => [...exp, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //Skills
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}skill/listSkill`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.skillName };
          setSkills((skill) => [...skill, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //Industry
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}industry/listIndustry`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.industryName };
          setIndustry((inds) => [...inds, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //Post Job
  const handlePostJob = () => {
    if (!jobData.jobTitle) {
      showNotification({
        title: "Invalid Data",
        message: "Please Enter job title!",
        color: "red",
      });
    } else {
      let formData = new FormData();
      Object.keys(jobData).forEach((key) => formData.append(key, jobData[key]));
      const options = {
        method: "POST",
        headers: {
          Accept: "application/form-data",
          // "content-type": "application/form-data",
        },
        body: formData,
      };
      fetch(`${backendUrl}job/addJob`, options)
        .then((response) => response.json())
        .then((response) => {
          navigate(routeNames.employer.myJobs);
        })
        .catch((err) => console.error(err));
    }
  };

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="e-dashboard">
        <div className="dash-a">
          <h2 className="text-dark">Post a Job</h2>
          <div className="postJob">
            <div className="d-flex row">
              <div className="col-md-6">
                <p style={{ margin: "0px", fontWeight: "500" }}>Job Title</p>
                <InputField
                  placeholder="Enter Job Title"
                  style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
                  onChange={(v) =>
                    setJobData((jobData) => ({
                      ...jobData,
                      jobTitle: v.target.value,
                    }))
                  }
                />
              </div>
              <Select
                label="Job Location"
                placeholder="Select..."
                data={loc}
                searchable
                creatable
                nothingFound="No Location Found"
                className="col-md-6 h-100"
                maxDropdownHeight={400}
                getCreateLabel={(query) => `${query}`}
                onChange={(v) =>
                  setJobData((jobData) => ({ ...jobData, empLocation: v }))
                }
              />
            </div>

            <MultiSelect
              label="Company Industry"
              placeholder="Select..."
              data={industry}
              searchable
              creatable
              maxDropdownHeight={400}
              getCreateLabel={(query) => `${query}`}
              onChange={(v) =>
                setJobData((jobData) => ({ ...jobData, industry: v.join(",") }))
              }
            />
            <MultiSelect
              label="Rrquired Skills"
              placeholder="Select..."
              data={skills}
              searchable
              creatable
              maxDropdownHeight={400}
              getCreateLabel={(query) => `${query}`}
              onChange={(v) =>
                setJobData((jobData) => ({ ...jobData, skills: v.join(",") }))
              }
            />
            <Checkbox.Group
              label="Job Type"
              size="xs"
              onChange={(v) =>
                setJobData((jobData) => ({
                  ...jobData,
                  jobType: v.join(","),
                }))
              }
            >
              <div className="d-flex w-100 row justify-content-between">
                {emp &&
                  emp.map((obj, key) => (
                    <Checkbox
                      classNames="col-md-6"
                      key={key}
                      value={obj.value}
                      label={obj.label}
                      className="w-50"
                      color="red"
                    />
                  ))}
              </div>
            </Checkbox.Group>
          </div>

          <div className="postJob">
            <div className="d-flex row justify-content-between">
              <Select
                label="Required Education"
                placeholder="Any..."
                onChange={(v) =>
                  setJobData((jobData) => ({ ...jobData, education: v }))
                }
                data={edu}
                maxDropdownHeight={400}
                className="col-md-6"
                nothingFound="Nothing here"
              />
              <Select
                label="Required Experience"
                placeholder="Any..."
                onChange={(v) =>
                  setJobData((jobData) => ({ ...jobData, experience: v }))
                }
                data={exp}
                maxDropdownHeight={400}
                nothingFound="Nothing here"
                className="col-md-6"
              />
            </div>
            <p style={{ margin: "0px", fontWeight: "500" }}>Salary Range</p>
            <div className="d-flex row gap-2">
              <div className="col-md-4">
                <InputField
                  placeholder="Min Salary"
                  style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
                  value={jobData?.minSalary}
                  onChange={(v) =>
                    setJobData((jobData) => ({
                      ...jobData,
                      minSalary: v.target.value,
                    }))
                  }
                />
              </div>
              <div className="col-md-4">
                <InputField
                  placeholder="Max Salary"
                  style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
                  value={jobData?.maxSalary}
                  onChange={(v) =>
                    setJobData((jobData) => ({
                      ...jobData,
                      maxSalary: v.target.value,
                    }))
                  }
                />
              </div>
              <div className="col-md-3">
                <Select
                  placeholder="Salary Type"
                  defaultValue={"hourly"}
                  onChange={(v) =>
                    setJobData((jobData) => ({ ...jobData, salaryRange: v }))
                  }
                  data={[
                    { label: "Hourly", value: "hourly" },
                    { label: "Monthly", value: "monthly" },
                  ]}
                  maxDropdownHeight={400}
                  className="h-100"
                  nothingFound="Nothing here"
                />
              </div>
            </div>
            {/* <RangeSlider
              defaultValue={[jobData?.minSalary || 0, jobData?.maxSalary || 70]}
              label={(val) => val + "$"}
              onChange={(v) =>
                setJobData((jobData) => ({
                  ...jobData,
                  minSalary: v[0],
                  maxSalary: v[1],
                }))
              }
            /> */}
            <Checkbox
              label="Comission / Bonus."
              color="red"
              onChange={(v) =>
                setJobData((jobData) => ({
                  ...jobData,
                  commission: v.target.checked,
                }))
              }
              className="mt-2"
            />
            <p style={{ margin: "0px", fontWeight: "500" }}>Job Description</p>
            {/* <Editor
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              onEditorStateChange={setEditorState}

              // onChange={(v) =>
              //   setJobData((jobData) => ({ ...jobData, jobDescription:v.target.value }))
              // }
            /> */}
            <textarea
              placeholder="Enter job description"
              rows={5}
              style={{
                border: "1px solid rgb(0,0,0,0.1)",
                borderRadius: "10px",
                padding: "5px",
                outline: "none",
              }}
              onChange={(v) =>
                setJobData((jobData) => ({
                  ...jobData,
                  jobDescription: v.target.value,
                }))
              }
            />
          </div>

          <div className="job-buttons">
            <Button
              title="Cancel"
              onClick={() => navigate(routeNames.employer.dashboard)}
            />
            <Button title="Post Job" primary={true} onClick={handlePostJob} />
          </div>
        </div>
        <div
          className="dash-b"
          hidden={location.pathname.includes("/admin/") ? true : false}
        >
          <CompleteProfile />
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
